// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"A2-z"};